<template>
  <div class="header">
    <router-link to="/">
      <img
        src="@/assets/images/logo.png"
        loading="lazy"
        alt="Logo"
        class="logo"
      />
    </router-link>
    <el-button type="primary" @click="toLogin()" v-if="showLoginButton"
      >登录</el-button
    >
    <el-dropdown v-show="showDropdown">
      <span class="el-dropdown-link">
        <el-avatar :size="40" :src="head_url"></el-avatar>
      </span>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item
          ><div style="text-align: center">
            {{ username }}
          </div></el-dropdown-item
        >
        <el-dropdown-item
          ><el-button type="text" @click="logOut()"
            >退出登录</el-button
          ></el-dropdown-item
        >
      </el-dropdown-menu>
    </el-dropdown>
  </div>
</template>

<script>
import api from "@/services/api";

export default {
  name: "Header",
  data() {
    return {
      username: "",
      head_url: "",
      showLoginButton: true,
      showDropdown: false,
    };
  },
  // Vue 生命周期钩子，组件挂载到DOM后调用
  mounted() {
    this.getUserInfo();
  },
  methods: {
    // 跳往登录
    toLogin() {
      // 获取当前页面的 URL
      const currentUrl = window.location.href;
      // 读取配置项 SSO_LOGIN_URL
      const ssoLoginUrl = process.env.SSO_LOGIN_URL;
      // 新的 URL 地址
      const loginUrl =
        ssoLoginUrl + "?redirect_url=" + encodeURIComponent(currentUrl);
      // 跳转到新的 URL 地址
      window.location.href = loginUrl;
    },

    // 获取用户信息
    getUserInfo() {
      var token = $cookies.get("token");
      if (token && token != "") {
        this.username = $cookies.get("username");
        this.head_url = $cookies.get("head_url");
        // 控制登录按钮的显示与隐藏
        this.showLoginButton = false;
        // 控制下拉菜单的显示与隐藏
        this.showDropdown = true;
      } else {
        //未登录
        var account_code = localStorage.getItem("account_code");
        if (account_code != undefined && account_code != "") {
          // 调用 API 请求，拿 token 去换取 code
          api.getTokenByCode(account_code).then((res) => {
            const { code, data } = res;
            if (code == 200) {
              var period = data.expirein_time - Math.floor(Date.now() / 1000); // 有效期
              $cookies.set("token", data.token, period);
              $cookies.set("username", data.username, period);
              $cookies.set("head_url", data.head_url, period);
              $cookies.set("user_id", data.userId, period);
              localStorage.removeItem("account_code");
              this.username = $cookies.get("username");
              this.head_url = $cookies.get("head_url");
              // 控制登录按钮的显示与隐藏
              this.showLoginButton = false;
              // 控制下拉菜单的显示与隐藏
              this.showDropdown = true;
            }
          });
        }
      }
    },

    // 退出登录
    logOut() {
      $cookies.remove("token");
      $cookies.remove("username");
      $cookies.remove("head_url");
      this.showLoginButton = true;
      this.showDropdown = false;
    },
  },
};
</script>

<style scoped>
.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 20px;
  background-color: orange;
  height: 60px;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 99999;
}

.logo {
  height: 40px;
}
@media screen and (max-width: 540px) {
  .header {
    width: calc(100vw - 40px);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Header.vue